import { useState } from 'react'
import DataTable from '../components/DataTable';
import { KTSVG } from '../../_metronic/helpers'
import Swal from 'sweetalert2'
import DefaultTermCreate from '../components/DefaultTermCreate';
import GetPagePermission from '../components/GetPagePermission';
import 'react-loading-skeleton/dist/skeleton.css';

function DefaultTermsList() {

    const hasPermission = GetPagePermission('/default-terms');
    const [newData, setNewData] = useState({});
    const [id, setId] = useState(0);
    const [createModalShow, setCreateModalShow] = useState(false);

    const handleCreateModalShow = () => {
        setId(0);
        setCreateModalShow(true);
    }

    const handleCreateModalClose = (isReload: boolean) => {
        setCreateModalShow(false);
        if (isReload) {
            setNewData({ id: Date.now() });
        }
    }

    const deleteDefaultTerm = (id: number): void => {
        if (window.confirm('Are you sure you want to delete this default term?')) {
            const myToken: string | null = localStorage.getItem('MyToken');
            let jwt: string | null = (myToken != null) ? JSON.parse(myToken) : null;
            fetch(`${process.env.REACT_APP_API_URL}default-terms/${id}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwt}` }
            })
                .then((resp: Response) => resp.json())
                .then((resp: any) => {
                    if (resp.success) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Deleted!',
                            text: resp.successMessage,
                        });
                        setNewData({ id: Date.now() });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: resp.errorMessage || 'Delete failed.',
                        });
                    }
                })
                .catch((error: any) => {
                    console.log(error, 'catch the hoop');
                });
        }
    };

    const editDefaultTerm = (id: number): void => {
        setId(id);
        setCreateModalShow(true);
    };

    const columns = [
        { value: 'id', title: 'Id', style: { textAlign: 'center' } },
        { value: 'projectName', title: 'Project', style: { textAlign: 'left' } },
        { value: 'terms', title: 'Terms', style: { textAlign: 'left' } },
        {
            value: 'action', title: 'Action', style: { textAlign: 'left', whiteSpace: 'nowrap' }, hasActionsComponent: true, actionsComponent: ((row: any) => {
                return (
                    <>
                        <button className="btn btn-light-primary btn-sm" onClick={() => editDefaultTerm(row.id)}>
                            <KTSVG
                                path='/media/svg/icons/Communication/Write.svg'
                                className='svg-icon-5 svg-icon'
                            />		Edit
                        </button>

                        <button className="btn btn-light-danger btn-sm p-2" onClick={() => deleteDefaultTerm(row.id)}>
                            <KTSVG
                                path='/media/svg/icons/General/Trash.svg'
                                className='svg-icon-5 svg-icon'
                            />		Delete
                        </button>
                    </>
                )
            })
        }
    ]

    const filters = {
        id: {
            filterType: 'like',
            filterValue: '',
        },
        projectName: {
            filterType: 'like',
            filterValue: '',
        },
        terms: {
            filterType: 'like',
            filterValue: '',
        },
    }

    const url = process.env.REACT_APP_API_URL + 'default-terms/dt'

    return (
        <>
            {hasPermission === 1 &&
                <div className='card card-custom'>
                    <div className='card-header'>
                        <div className="card-title">
                            <KTSVG path='/media/svg/icons/Text/Bullet-list.svg' className='svg-icon-1 svg-icon-primary' />
                            <span className='text fw-bolder' style={{ marginLeft: '10px' }}>
                                Default Terms
                            </span>
                        </div>
                        <div className="card-toolbar">
                            <div className='d-flex justify-content-end'>
                                <button type="button" className="btn btn-sm btn-primary" onClick={() => handleCreateModalShow()}><i className="fa fa-plus"></i>Add Default Term</button>
                            </div>
                        </div>
                    </div>

                    <div className='card-body'>
                        <DataTable url={url} columns={columns} filters={filters} newData={newData} />
                    </div>
                </div>
            }

            <DefaultTermCreate show={createModalShow} handleClose={handleCreateModalClose} id={id} />
        </>
    )
}

export default DefaultTermsList
